export type PlanType = 'daily' | 'weekly' | 'monthly';

export interface SubscriptionPlan {
  id: PlanType;
  name: string;
  duration: string;
  durationDays: number;
  subscriptionId: string;
  price: number;
  originalPrice?: number;
  popular: boolean;
  discount?: string;
  features: string[];
}

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: 'daily',
    name: 'Daily Pack',
    duration: '1 Day',
    durationDays: 1,
    subscriptionId: '26801220000007959',
    price: 1,
    popular: false,
    features: ['Unlimited Videos', 'HD Quality', 'Mobile Access', 'Ad-Free Experience'],
  },
  {
    id: 'weekly',
    name: 'Weekly Pack',
    duration: '7 Days',
    durationDays: 7,
    subscriptionId: '26801220000007961',
    price: 5,
    originalPrice: 15,
    discount: '29% OFF',
    popular: false,
    features: ['Unlimited Videos', 'HD Quality', 'Mobile & Desktop', 'Ad-Free Experience', 'Early Access'],
  },
  {
    id: 'monthly',
    name: 'Monthly Pass',
    duration: '30 Days',
    durationDays: 30,
    subscriptionId: '26801220000007962',
    price: 15,
    originalPrice: 25,
    discount: '40% OFF',
    popular: true,
    features: ['Unlimited Videos', '4K Quality', 'All Devices', 'Ad-Free Experience', 'Early Access', 'Exclusive Content', 'Priority Support'],
  },
];

export const getPlanById = (planId: PlanType): SubscriptionPlan | undefined =>
  SUBSCRIPTION_PLANS.find((plan) => plan.id === planId);

export const getPlanBySubscriptionId = (subscriptionId: string): SubscriptionPlan | undefined =>
  SUBSCRIPTION_PLANS.find((plan) => plan.subscriptionId === subscriptionId);
